/** Relógio do jogo: `mm:ss`, ou `h:mm:ss` a partir de uma hora. */
export function formatClock(totalSeconds: number): string {
  const total = Number.isFinite(totalSeconds) ? Math.max(0, Math.floor(totalSeconds)) : 0;
  const hours = Math.floor(total / 3600);
  const minutes = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
  const seconds = String(total % 60).padStart(2, '0');
  return hours > 0 ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
}

/** Tempo enviado ao terminar: inteiro ≥ 1 (o ranking de torneio ignora tempo 0). */
export function finishTempo(seconds: number): number {
  return Number.isFinite(seconds) ? Math.max(1, Math.round(seconds)) : 1;
}
